<script setup>
import Card from '@/Components/Card/Card.vue';
import AuthHeader from '@/Pages/HeaderAnalysis/Partials/AuthHeader.vue';
import CardLabel from '@/Components/Card/CardLabel.vue';

defineProps({
  auth: Object
});
</script>

<template>
  <div>
    <CardLabel
      :label="
        $t(
          'header_analysis.partials.authentication_summary.authentication_summary'
        )
      "
    />
    <Card>
      <AuthHeader
        title="SPF"
        :passes="auth.spf_passes"
        :other="auth.spf_other"
      />
      <AuthHeader
        title="DKIM"
        :passes="auth.dkim_passes"
        :other="auth.dkim_other"
      />
      <AuthHeader
        title="DMARC"
        :passes="auth.dmarc_passes"
        :other="auth.dmarc_other"
      />
      <hr class="bg-grey-200 mt-4 mb-2" />
      <a
        class="text-primary-400 hover:text-primary-300 ml-1 underline"
        href="#authentication-results"
      >
        {{ $t('header_analysis.partials.authentication_summary.view_results') }}
      </a>
    </Card>
  </div>
</template>
